import React from 'react';
import { SvgIcon } from '@mui/material';

export function FillTelegramIcon(props) {
  return (
    <SvgIcon viewBox="0 0 42 42" {...props}>
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {!props.noFill && (
          <rect width="42" height="42" rx="16" fill="#FFBC5B" />
        )}
        <path
          d="M32.9316 13.7297L29.3099 29.8531C29.0366 30.991 28.3241 31.2742 27.3115 30.7381L21.7931 26.8995L19.1304 29.317C18.8357 29.5951 18.5893 29.8278 18.0214 29.8278L18.4178 24.5225L28.6455 15.7982C29.0902 15.424 28.5491 15.2166 27.9544 15.5909L15.3104 23.1063L9.86706 21.4981C8.68303 21.1491 8.66159 20.3803 10.1135 19.8442L31.4047 12.1012C32.3905 11.7522 33.2531 12.3085 32.9316 13.7297Z"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
